// To config available list views

const availableListViews = {
  "table": true,
  "grid": false
}

export default availableListViews;